import React from 'react';
import Tooltip from 'components/Tooltip';
import NavIconItem from '../../../Common/NavIconItem';
import { NavLink } from 'react-router-dom';
import Icon from '../../../../../../kingpin/atoms/Icon';

const Settings = () => {
  return (
    <Tooltip content={'Settings'}>
      <NavLink to={'/settings'}>
        <NavIconItem>
          <Icon
            icon="settings-empty"
            color="var(--color-icon-primary)"
            width={19}
            height={19}
          />
        </NavIconItem>
      </NavLink>
    </Tooltip>
  );
};

export default Settings;
